import * as S from "./style.ColumnHeaderSelector";
import React, { useEffect, useMemo, useState } from "react";
import ReactSelect  from "react-select";
import { ISearchBox, TableHeader, CSVHeader, IDropDown } from '../../types/type';





const ColumnHeaderSelector = ({title, options, selected, setSelected }:any) => {


  const [selectedOption, setSelectedOption] = useState<CSVHeader[]>([]);

  
  const handleChange = (newValue:any) => {
    if(selected.length ===0){
      setSelected((prev:IDropDown[]) => {
        return [...prev, { value : newValue.value, label : newValue.label,}]
        });
    }else if(selected.length >0){
      const existVal = selected[0].value;   
      if(newValue==null){setSelected([]); return;}
      if(existVal !== newValue.value){
        setSelected([]);
        setSelected((prev:IDropDown[]) => {
          return [...prev, { value : newValue.value, label : newValue.label,}]
          });
      }
    }
    
  };

  const customStyles = {

    valueContainer: (provided:any, state:any) => ({
      ...provided,
      textOverflow: "ellipsis",
      maxWidth: "95%",
      //whiteSpace: "nowrap",
      //overflow: "hidden",
      //display: "initial",
      height: '30px',
    }),

    // input: (provided:any, state:any) => ({
    //   ...provided,
    //   margin: '0px',
    // }),

    // indicatorSeparator: (state:any) => ({
    //   display: 'none',
    // }),
    // indicatorsContainer: (provided:any, state:any) => ({
    //   ...provided,
    //   height: '30px',
    // }),

    placeholder: (defaultStyles:any) => ({  
      ...defaultStyles,
      fontSize: '13px'      
    }),

    singleValue: (defaultStyles:any) => ({  
      ...defaultStyles,
      fontSize: '13px',
      // fontWeight : 'bold'
    }),


    option: (styles:any, { data, isDisabled, isFocused, isSelected }:any) => {
      
      //console.log({ data, isDisabled, isFocused, isSelected });
      return {
        ...styles,
        backgroundColor: isSelected ? "lightgray" : "white",
        color: "#333333",
        fontSize : "13px",
        "&:hover": {                                           // overriding hover
          ...styles,                                          // apply initial styles         
        },
        borderRadius: 5,
      };
    }

  };

  return (
      <S.Container>
        <div className='header'>{title}</div>
        <div className="App">
          <ReactSelect
            defaultValue={selectedOption}
            //@ts-ignore
            onChange={handleChange}
            options={options}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            isSearchable={true}
            styles={customStyles}
            isClearable={true}
            theme={(theme) => ({
                ...theme,
                borderRadius: 10,
                colors: {
                  ...theme.colors,
                  primary25: 'lightgray',
                  primary: '#333333',
                },
              })}
          />
        </div>
      </S.Container>
  );


};


export default ColumnHeaderSelector;
